import React, { Component } from 'react'
import classes from './Home.scss'
import Bigbox from '../../../components/PageContent/Home/BigBox/BigBox'

import { connect } from 'react-redux'
import * as actions from '../../../store/actions/index'
import { Autocomplete } from '@material-ui/lab'
import { TextField, Grid } from '@material-ui/core'
import withTranslate from 'react-redux-multilingual/lib/withTranslate'
class Home extends Component {
  state = {
    option: [{ value: '', label: '' }],
    selectedOption: { value: '', label: '' },
    updateProps: {
      selectedRecord: this.props.selectedRecord,
      companyOptions: this.props.companyOptions
    }
  }

  componentDidMount() {
    this.props.fetchOptions()
  }
  static getDerivedStateFromProps = (props, state) => {
    let updatedState = {}
    let { updateProps } = state
    if (props.companyOptions !== updateProps.companyOptions) {
      let data = props.companyOptions.map(res => {
        return {
          value: res.company_id,
          label: res.company_name
        }
      })

      const selectedCompany = data[0] || null

      updatedState = {
        ...updatedState,
        option: data,
        selectedOption: selectedCompany,
        updateProps: {
          ...updateProps,
          companyOptions: props.companyOptions
        }
      }
      if (selectedCompany) {
        props.fetchData(selectedCompany.value)
      }
    }

    return updatedState
  }
  handleChange = (e, data) => {
    this.setState({
      selectedOption: data
    })
    this.props.fetchData(data?.value)
  }
  render() {
    const { option, selectedOption } = this.state
    const { translate } = this.props

    return (
      <Grid container>
        <Grid
          container
          spacing={2}
          style={{ margin: '8px 0', backgroundColor: 'white', border: '1px solid #ced6e0' }}>
          <Grid item xs md lg={3} xl={2}>
            <Autocomplete
              options={option}
              onChange={this.handleChange}
              value={selectedOption}
              getOptionLabel={option => option.label || ''}
              renderInput={params => <TextField style={{ width: '100%' }} fullWidth {...params} />}
            />
          </Grid>
        </Grid>
        <div className={classes.grid}>
          <div className={[classes.value, classes.Box].join(' ')}>
            <div className={classes.Center}>
              <Bigbox header={translate('value')}>
                {this.props.selectedRecord?.core_values || 'No Data'}
              </Bigbox>
            </div>
          </div>
          <div className={[classes.Swot, classes.Box].join(' ')}>
            <div className={classes.Center}>
              <Bigbox header={translate('swotAnalysis')}>
                {this.props.selectedRecord?.swot || 'No Data'}
              </Bigbox>
            </div>
          </div>
          <div className={[classes.Vision, classes.Box].join(' ')}>
            <Bigbox header={translate('vision')}>
              {this.props.selectedRecord?.vision || 'No Data'}
            </Bigbox>
          </div>
          <div className={[classes.Mission, classes.Box].join(' ')}>
            <Bigbox header={translate('mission')}>
              {this.props.selectedRecord?.mission || 'No Data'}
            </Bigbox>
          </div>
        </div>
      </Grid>
    )
  }
}

const mapStateToProps = state => {
  return {
    selectedRecord: state.home.selectedRecord,
    companyOptions: state.home.company
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchOptions: () => dispatch(actions.fetchCompanyOptions()),
    fetchData: recordId => dispatch(actions.fetchCompanyById(recordId))
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(withTranslate(Home))
